import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { logWarning } from '@savgroup-front-common/configuration/appInsights/AppInsights';

import { intl, showMessageId } from '../helpers/intl';
import { collectMissingDynamicTerm } from '../services/dynamicTermSuggestion/dynamicTermSuggestionStore';

export const SafeFormattedMessageWithId: FC<{
  id?: string;
  values?: Record<string, string>;
  basePath?: string;
}> = ({ id, values, basePath }) => {
  'use no memo';
  let messageId = id;

  if (!messageId) {
    return null;
  }

  const isMessageExist = intl?.messages[`${basePath}${messageId}`];

  if (basePath && isMessageExist) {
    messageId = `${basePath}${messageId}`;
  } else if (basePath) {
    logWarning(
      `[PO-EDITOR]: message "${basePath}${id}" does not have a corresponding message in Dynamic messages.`,
    );

    collectMissingDynamicTerm({ messageId: `${basePath}${messageId}` });
  }

  const el = React.createElement(FormattedMessage, {
    ...{ id: messageId, values },
  });
  const span = React.createElement('span', { title: id }, el);

  if (showMessageId) {
    return span;
  }

  return el;
};
